import {
  ScatterChart, Scatter, XAxis, YAxis, ZAxis, CartesianGrid, ResponsiveContainer, Tooltip, Legend,
} from "recharts";
import { wbChartData } from "@/lib/navcalc";
import { MoveLeft, MoveRight } from "lucide-react";

const f2 = (v) => (Number(v) || 0).toFixed(2);

const Tip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const p = payload[0].payload;
  return (
    <div data-testid="wb-chart-tooltip" className="rounded-lg border border-slate-600 bg-[#0D1527] px-3 py-2 font-mono-data text-xs text-white shadow-lg">
      {p.label && <div className="mb-1 font-semibold text-white">{p.label}</div>}
      <div>CG : {f2(p.cg)} m</div>
      <div>Masse : {f2(p.weight)} kg</div>
    </div>
  );
};

const MODES = [["both", "Destination + retour"], ["dest", "Destination"], ["return", "Retour"]];

// Enveloppe + droite décollage → carburant mini (non utilisable) + point(s) d'atterrissage.
export default function WBChart({ wb, aircraft, briefing, nav, setBriefing, height = 360 }) {
  const { envelope, takeoff, minFuel, landings, mode } = wbChartData(wb, aircraft, briefing, nav);
  const envelopeClosed = envelope.length ? [...envelope, envelope[0]] : [];

  return (
    <div>
      {nav.ret && setBriefing && (
        <div className="mb-3 flex flex-wrap items-center gap-2" data-testid="wb-landing-mode">
          <span className="text-[11px] uppercase tracking-wider text-slate-500">Point(s) atterrissage :</span>
          {MODES.map(([k, l]) => (
            <button key={k} onClick={() => setBriefing((b) => ({ ...b, wbLandingMode: k }))} data-testid={`wb-landing-mode-${k}`}
              className={`rounded-md border px-2.5 py-1 text-xs ${mode === k ? "border-cyan-500/50 bg-cyan-500/15 text-cyan-300" : "border-slate-700 text-slate-400 hover:text-slate-200"}`}>
              {l}
            </button>
          ))}
        </div>
      )}
      <div data-testid="wb-envelope-chart" className="w-full" style={{ height }}>
        <ResponsiveContainer width="100%" height="100%">
          <ScatterChart margin={{ top: 10, right: 20, bottom: 20, left: 0 }}>
            <CartesianGrid stroke="#1E2D4A" strokeDasharray="3 3" />
            <XAxis type="number" dataKey="cg" name="CG" unit=" m" domain={["auto", "auto"]} stroke="#64748B" tick={{ fill: "#64748B", fontSize: 11 }}
              label={{ value: "CG / Bras (m)", position: "insideBottom", offset: -10, fill: "#64748B", fontSize: 11 }} />
            <YAxis type="number" dataKey="weight" name="Masse" unit=" kg" domain={["auto", "auto"]} stroke="#64748B" tick={{ fill: "#64748B", fontSize: 11 }} />
            <ZAxis range={[120, 121]} />
            <Tooltip cursor={{ strokeDasharray: "3 3" }} content={<Tip />} />
            <Legend verticalAlign="top" height={24} wrapperStyle={{ fontSize: 11, color: "#94A3B8" }} />
            <Scatter name="Enveloppe" data={envelopeClosed} line={{ stroke: "#00E5FF", strokeWidth: 2 }} fill="rgba(0,229,255,0.12)" shape={() => null} legendType="line" />
            <Scatter name="Consommation carburant" data={[takeoff, minFuel]} line={{ stroke: "#FFB000", strokeWidth: 2, strokeDasharray: "6 4" }} fill="#FFB000" shape={() => null} legendType="line" />
            <Scatter name="Décollage" data={[takeoff]} fill="#FFB000" />
            <Scatter name="Atterrissage" data={landings} fill="#34D399" />
            <Scatter name="Carburant mini" data={[minFuel]} fill="#F43F5E" />
          </ScatterChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-1 flex items-center justify-between px-2 text-[11px] font-medium" data-testid="wb-stability-hint">
        <span className="flex items-center gap-1 text-sky-300"><MoveLeft className="h-3.5 w-3.5" /> Plus stable (centrage avant)</span>
        <span className="flex items-center gap-1 text-amber-300">Plus maniable (centrage arrière) <MoveRight className="h-3.5 w-3.5" /></span>
      </div>
      <p className="mt-2 text-center text-xs text-slate-500">
        Droite ambre : du décollage jusqu'au carburant non utilisable · point vert : atterrissage selon la conso du log de nav · contour cyan : limites certifiées
      </p>
    </div>
  );
}
